import {createSlice, original } from '@reduxjs/toolkit'

const StaffSlice = createSlice({
    name: "StaffSlice",
    initialState: {
        StaffArray: [], 
        StaffSelectedCityArray: [],
        HoursStaffKashierArray: [],
        HoursStaffCookArray: [],
        HoursStaffCookSecondGroupArray: [],
        StaffAllMonth: [],
        ResultKashier: {
            Result: [],
            FirstTotalSum: 0,
            SecondTotalSum: 0,
            TotalSum: 0
        },
        ResultCook: {
            Result: [],
            FirstTotalSum: 0,
            SecondTotalSum: 0,
            TotalSum: 0
        },
        ResultCookSecondGroup: {
            Result: [],
            FirstTotalSum: 0,
            SecondTotalSum: 0,
            TotalSum: 0
        },
        ResultManager: {
            Result: [],
            FirstTotalSum: 0,
            SecondTotalSum: 0,
            TotalSum: 0
        },
        ResultOther: {
            Result: [],
            FirstTotalSum: 0,
            SecondTotalSum: 0,
            TotalSum: 0
        },
        ResultFOT: {
            Result: [],
            FirstTotalSum: 0,
            SecondTotalSum: 0,
            TotalSum: 0
        }
    },
    reducers: {
        StaffArrayAdd(state, actions){
            state.StaffArray = actions.payload
        },
        StaffSelectedCityArrayAdd(state, actions){
            state.StaffSelectedCityArray = actions.payload
        },
        StaffHours(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                var FirstHour = 0
                var SecondHour = 0
                
                    try{
                        var Hours = el.Hours.split('_')
                    
                    var Additional = el.Additional.split('_')
                    var HoursAndId = []
                    var AdditionalAndId = []
                    Hours.map((a, index) => {
                            
                        HoursAndId = [...HoursAndId, {id: (parseInt(index)), Value: a}]
                        return(a)
                    })
    
                    Additional.map((a, index) => {
                            
                        AdditionalAndId = [...AdditionalAndId, {id: (parseInt(index) + 1), Value: a}]
                        return(a)    
                    })
                    
                    el.FirstBonus = AdditionalAndId[0]
                    el.SecondBonus = AdditionalAndId[2]
                    el.FirstFine = AdditionalAndId[1]
                    el.SecondFine = AdditionalAndId[3]
                    el.Hours = HoursAndId

                    HoursAndId.map((a) => {
                        if(a.id > actions.payload.MinDay && a.id < actions.payload.MaxDay)
                            if(a.id < 15)
                            {
                                FirstHour = FirstHour + parseFloat(a.Value)
                            }
                            else
                            {
                                SecondHour = SecondHour + parseFloat(a.Value)
                            }
                            return(a)
                        })
                        el.SecondHour = SecondHour
                        el.FirstHour = FirstHour
                        el.TotalHour = parseFloat(FirstHour) + parseFloat(SecondHour)
                    }

                    catch{
                        el.Hours.map((a) => {
                            if(a.id > actions.payload.MinDay && a.id < actions.payload.MaxDay)
                            if(a.id < 15)
                                {
                                    FirstHour = FirstHour + parseFloat(a.Value)
                                }
                                else
                                {
                                    SecondHour = SecondHour + parseFloat(a.Value)
                                }
                            return(a)
                            })
                            el.SecondHour = SecondHour
                            el.FirstHour = FirstHour
                            el.TotalHour = parseFloat(FirstHour) + parseFloat(SecondHour)
                    }
                        
                
                return(el)
            })
        },
        StaffOneDaySumHours(state, actions){
            if(actions.payload === 0)
                {
                    state.HoursStaffKashierArray = []
                    state.HoursStaffCookArray = []
                    state.HoursStaffCookSecondGroupArray = []
                }
            state.StaffSelectedCityArray.map((el) =>{
            if(el.Hidden !== true) {
                    if(el.Post === 'Кассир')
                    {
                        if(state.HoursStaffKashierArray[actions.payload] > 0)
                            {
                            state.HoursStaffKashierArray[actions.payload] = parseFloat(state.HoursStaffKashierArray[actions.payload]) + parseFloat(el.Hours[actions.payload].Value)
                            }
                        else
                            {
                            state.HoursStaffKashierArray[actions.payload] = parseFloat(el.Hours[actions.payload].Value)
                            }
                    }
                    if(el.Post === 'Повар' || el.Post === 'Повар 1 группа')
                    {
                        if(state.HoursStaffCookArray[actions.payload] > 0)
                            {
                            state.HoursStaffCookArray[actions.payload] = parseFloat(state.HoursStaffCookArray[actions.payload]) + parseFloat(el.Hours[actions.payload].Value)
                            }
                        else
                            {
                            state.HoursStaffCookArray[actions.payload] = parseFloat(el.Hours[actions.payload].Value)
                            }

                    }
                    if(el.Post === 'Повар 2 группа')
                        {
                            if(state.HoursStaffCookSecondGroupArray[actions.payload] > 0)
                                {
                                state.HoursStaffCookSecondGroupArray[actions.payload] = parseFloat(state.HoursStaffCookSecondGroupArray[actions.payload]) + parseFloat(el.Hours[actions.payload].Value)
                                }
                            else
                                {
                                state.HoursStaffCookSecondGroupArray[actions.payload] = parseFloat(el.Hours[actions.payload].Value)
                                }
    
                        }
                }
                    return(el)
            })
        },
        changeValueStaff(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.idStaff)
                    {
                        var FirstHour = 0
                        var SecondHour = 0
                        el.Hours.map((a) => {
                            if(a.id === actions.payload.idValue)
                                {
                                    a.Value = actions.payload.Value
                                }
                            return(a)
                        })
                        el.Hours.map((a) => {
                            if(a.id > actions.payload.MinDay && a.id < actions.payload.MaxDay)
                            if(a.id < 15)
                                {
                                    FirstHour = FirstHour + parseFloat(a.Value)
                                }
                                else
                                {
                                    SecondHour = SecondHour + parseFloat(a.Value)
                                }
                            return(a)
                            })
                            el.SecondHour = SecondHour
                            el.FirstHour = FirstHour
                            el.TotalHour = parseFloat(FirstHour) + parseFloat(SecondHour)
                    }
                    return(el)
            })
        },
        TotalSumHour(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.id)
                    {
                        var FirstHour = 0
                        var SecondHour = 0
                        el.Hours.map((a) => {
                            if(a.id > actions.payload.MinDay && a.id < actions.payload.MaxDay)
                            if(a.id < 15)
                                {
                                    FirstHour = FirstHour + parseFloat(a.Value)
                                }
                                else
                                {
                                    SecondHour = SecondHour + parseFloat(a.Value)
                                }
                        return(a)
                        })
                        el.SecondHour = SecondHour
                        el.FirstHour = FirstHour
                        el.TotalHour = parseFloat(FirstHour) + parseFloat(SecondHour)
                    }
                    return(el)
            })
        },
        ChangeFIO(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.id)
                    {
                        el.FIO = actions.payload.Value
                    }
                return(el)
            })
        },
        ChangeShift(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.id)
                {
                    if(actions.payload.Type === 'SecondShift')
                    {
                        el.SecondShift =  actions.payload.Value
                    }
                    else
                    {
                            el.Shift =  actions.payload.Value
                    }
                }
                return(el)
            })
        },
        ChangeRate(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.id)
                {
                    if(actions.payload.Type === 'SecondRate')
                    {
                        el.SecondRate =  actions.payload.Value
                    }
                    else
                    {
                        el.Rate =  actions.payload.Value
                    }
                }
                return(el)    
            })
        },
        ChangePrize(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.id)
                {
                    if(actions.payload.Type === 'SecondPrize')
                    {
                        el.SecondPrize =  actions.payload.Value
                    }
                    else
                    {
                        el.Prize =  actions.payload.Value
                    }   
                }
                return(el)
            })
        },
        ChangeAdditional(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.id)
                    {
                        switch(actions.payload.Type){
                            case('FirstBonus'):{
                                el.FirstBonus.Value  = actions.payload.Value
                                break;
                            }
                            case('SecondBonus'):{
                                el.SecondBonus.Value = actions.payload.Value
                                break;
                            }
                            case('FirstFine'):{
                                el.FirstFine.Value  = actions.payload.Value
                                break;
                            }
                            case('SecondFine'):{
                                el.SecondFine.Value  = actions.payload.Value
                                break;
                            }
                            default:{
                                break;
                            }
                        }
                    }
                return(el)
            })
        },
        setStaffAllMonth(state, actions){
            state.StaffAllMonth = actions.payload
        },
        setHoursStaff(state, actions){
            state.StaffArray.map((el) => {
                if(el.id === actions.payload.idStaff)
                {
                    el.idHourses = actions.payload.idHourses
                    el.Hours = actions.payload.Hours 
                    el.Additional = actions.payload.Additional
                    el.Rate = actions.payload.Rate
                    el.Shift = actions.payload.Shift
                    el.Prize = actions.payload.Prize
                    el.SecondRate = actions.payload.SecondRate
                    el.SecondShift = actions.payload.SecondShift
                    el.SecondPrize = actions.payload.SecondPrize
                    el.Hidden = actions.payload.Hidden
                }
                return(el)
            })

            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.idStaff)
                {
                    el.idHourses = actions.payload.idHourses
                    el.Hours = actions.payload.Hours 
                    el.Additional = actions.payload.Additional
                    el.Rate = actions.payload.Rate
                    el.Shift = actions.payload.Shift
                    el.Prize = actions.payload.Prize
                    el.SecondRate = actions.payload.SecondRate
                    el.SecondShift = actions.payload.SecondShift
                    el.SecondPrize = actions.payload.SecondPrize
                    el.Hidden = actions.payload.Hidden
                }
                return(el)
            })
        },
        StaffChangeHidden(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload)
                {
                    el.Hidden = true
                    el.Additional = '0_0_0_0'
                    el.Hours.map((a) => {
                        a.Value = 0
                        return(a)
                    })
                }
                return(el)
            })
        },
        StaffUnHidden(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload)
                {
                    el.Hidden = false
                }
                return(el)
            })
        },
        setStaffDeletedStatus(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload)
                {
                    el.Deleted = String(parseInt(new Date().getMonth()) + 1) + '.' + String(new Date().getFullYear())
                }
                return(el)
            })
        },
        StaffUnDeletedStatus(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload)
                {
                    el.Deleted = 'false'
                }
                return(el)
            })
        },
        AddResult(state, actions){
            state.ResultKashier = {
                Result: [],
                FirstTotalSum: 0,
                SecondTotalSum: 0,
                TotalSum: 0
            }

            state.ResultCook = {
                Result: [],
                FirstTotalSum: 0,
                SecondTotalSum: 0,
                TotalSum: 0
            }

            state.ResultCookSecondGroup = {
                Result: [],
                FirstTotalSum: 0,
                SecondTotalSum: 0,
                TotalSum: 0
            }

            state.ResultManager = {
                Result: [],
                FirstTotalSum: 0,
                SecondTotalSum: 0,
                TotalSum: 0
            }

            state.ResultOther = {
                Result: [],
                FirstTotalSum: 0,
                SecondTotalSum: 0,
                TotalSum: 0
            }

            state.ResultFOT = {
                Result: [],
                FirstTotalSum: 0,
                SecondTotalSum: 0,
                TotalSum: 0
            }


            //Касса
            actions.payload.RevenueArray.map((el) => {
                state.StaffSelectedCityArray.length > 0 && state.ResultKashier.Result.push(state.StaffSelectedCityArray.reduce((Sum, a) => 
                    el.id < 15
                    ?
                    parseFloat(a.Hours[el.id].Value) > 0 
                        ?
                            a.Post === 'Кассир' 
                                ? 
                                    parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                    ?
                                    Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[el.id])))
                                    :
                                    Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13)))
                                :
                                Sum + 0
                        :
                        Sum + 0
                    :
                    parseFloat(a.Hours[el.id].Value) > 0 
                    ?
                        a.Post === 'Кассир' 
                            ? 
                                parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                ?
                                Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[el.id])))
                                :
                                Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13)))
                            :
                            Sum + 0
                    :
                    Sum + 0, 0
                    ).toFixed(2))
            return(el)
            })

            state.ResultKashier.FirstTotalSum = actions.payload.RevenueArray.reduce((TotalSum, item) => 
                item.id < 15
                ?
                    (actions.payload.Period.MaxDay > 14 ? item.id !== 14 : item.id !==  actions.payload.Period.MaxDay - 1)
                    ?
                        TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                            item.id >  actions.payload.Period.MinDay && item.id <  actions.payload.Period.MaxDay && 
                            parseFloat(a.Hours[item.id].Value) > 0 
                                ?
                                    a.Post === 'Кассир' 
                                        ? 
                                            parseFloat(item.Value) <  actions.payload.PercentCity.PrizeMinSum 
                                            ?
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])))
                                            :
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13)))
                                        :
                                        Sum + 0
                                :
                                Sum + 0, 0
                            )
                    :
                        TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                            item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                            parseFloat(a.Hours[item.id].Value) > 0 
                                ?
                                    a.Post === 'Кассир' 
                                        ? 
                                            parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                            ?
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id]))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                            :
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                        :
                                        Sum + 0
                                :
                                a.Post === 'Кассир' 
                                ? 
                                    Sum + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                :
                                Sum + 0
                                , 0
                            )
                :
                TotalSum + 0
                , 0).toFixed(2)

                state.ResultKashier.SecondTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                    item.id > 14 ? 
                                    item.id !== actions.payload.Period.MaxDay - 1
                                    ?
                                    TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                        item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay &&
                                        parseFloat(a.Hours[item.id].Value) > 0 
                                            ?
                                                a.Post === 'Кассир' 
                                                    ? 
                                                        parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13)))
                                                    :
                                                    Sum + 0
                                            :
                                            Sum + 0, 0
                                        )
                                    :
                                    TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                        item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay &&
                                        parseFloat(a.Hours[item.id].Value) > 0 
                                            ?
                                                a.Post === 'Кассир' 
                                                    ? 
                                                        parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id]))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                    :
                                                    Sum + 0
                                            :
                                            a.Post === 'Кассир' 
                                            ?
                                                Sum + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                            :
                                            Sum + 0, 0
                                        )   
                                :
                                TotalSum + 0
                            , 0).toFixed(2)
                state.ResultKashier.TotalSum = parseFloat(parseFloat(state.ResultKashier.FirstTotalSum) + parseFloat(state.ResultKashier.SecondTotalSum)).toFixed(2)

                //Повара

                actions.payload.RevenueArray.map((el) => { 
                    state.StaffSelectedCityArray.length > 0 && state.ResultCook.Result.push(state.StaffSelectedCityArray.reduce((Sum, a) => 
                        el.id < 15
                        ?
                        parseFloat(a.Hours[el.id].Value) > 0 
                            ?
                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                    ? 
                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                        ?
                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[el.id])))
                                        :
                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13)))
                                    :
                                    Sum + 0
                            :
                            Sum + 0
                        :
                        parseFloat(a.Hours[el.id].Value) > 0 
                            ?
                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                    ? 
                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                        ?
                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[el.id])))
                                        :
                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13)))
                                    :
                                    Sum + 0
                            :
                        Sum + 0, 0
                        ).toFixed(2))
                        return(el)
                })

                state.ResultCook.FirstTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                    item.id < 15 ?
                        (actions.payload.Period.MaxDay > 14 ? item.id !== 14 : item.id !==  actions.payload.Period.MaxDay - 1)
                        ?
                        TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                            item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                            parseFloat(a.Hours[item.id].Value) > 0 
                                ?
                                    (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                        ? 
                                            parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                            ?
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])))
                                            :
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13)))
                                        :
                                        Sum + 0
                                :
                                Sum + 0, 0
                            )
                        :
                        TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                            item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                            parseFloat(a.Hours[item.id].Value) > 0 
                                ?
                                    (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                        ? 
                                            parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                            ?
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id]))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                            :
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                        :
                                        Sum + 0
                                :
                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                ?
                                Sum + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                :
                                Sum + 0, 0
                            )
                        :
                        TotalSum + 0
                    , 0).toFixed(2)
                

                    state.ResultCook.SecondTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                        item.id > 14 ? 
                            item.id !== actions.payload.Period.MaxDay - 1
                            ?
                            TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                parseFloat(a.Hours[item.id].Value) > 0 
                                    ?
                                        (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                            ? 
                                                parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                ?
                                                
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])))
                                                :
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13)))
                                            :
                                            Sum + 0
                                    :
                                    Sum + 0, 0
                                )
                            :
                            TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                parseFloat(a.Hours[item.id].Value) > 0 
                                    ?
                                        (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                            ? 
                                                parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                ?
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id]))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                :
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                            :
                                            Sum + 0
                                    :
                                    (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                    ?
                                    Sum + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                    :
                                    Sum + 0, 0
                                )
                            :
                            TotalSum + 0
                        , 0).toFixed(2)

                    state.ResultCook.TotalSum = parseFloat(parseFloat(state.ResultCook.FirstTotalSum) + parseFloat(state.ResultCook.SecondTotalSum)).toFixed(2)

                //Повара 2 группа

                actions.payload.RevenueArray.map((el) => { 
                    state.StaffSelectedCityArray.length > 0 && state.ResultCookSecondGroup.Result.push(state.StaffSelectedCityArray.reduce((Sum, a) => 
                        el.id < 15
                        ?
                        parseFloat(a.Hours[el.id].Value) > 0 
                            ?
                                a.Post === 'Повар 2 группа'
                                    ? 
                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                        ?
                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[el.id])))
                                        :
                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13)))
                                    :
                                    Sum + 0
                            :
                            Sum + 0
                        :
                        parseFloat(a.Hours[el.id].Value) > 0 
                            ?
                                a.Post === 'Повар 2 группа'
                                    ? 
                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                        ?
                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[el.id])))
                                        :
                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13)))
                                    :
                                    Sum + 0
                            :
                        Sum + 0, 0
                        ).toFixed(2))
                        return(el)
                })

                state.ResultCookSecondGroup.FirstTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                    item.id < 15 ?
                        (actions.payload.Period.MaxDay > 14 ? item.id !== 14 : item.id !==  actions.payload.Period.MaxDay - 1)
                        ?
                        TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                            item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                            parseFloat(a.Hours[item.id].Value) > 0 
                                ?
                                    a.Post === 'Повар 2 группа'
                                        ? 
                                            parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                            ?
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])))
                                            :
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13)))
                                        :
                                        Sum + 0
                                :
                                Sum + 0, 0
                            )
                        :
                        TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                            item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                            parseFloat(a.Hours[item.id].Value) > 0 
                                ?
                                    a.Post === 'Повар 2 группа'
                                        ? 
                                            parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                            ?
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id]))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                            :
                                            Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                        :
                                        Sum + 0
                                :
                                a.Post === 'Повар 2 группа' 
                                ?
                                Sum + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                :
                                Sum + 0, 0
                            )
                        :
                        TotalSum + 0
                    , 0).toFixed(2)
                

                    state.ResultCookSecondGroup.SecondTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                        item.id > 14 ? 
                            item.id !== actions.payload.Period.MaxDay - 1
                            ?
                            TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                parseFloat(a.Hours[item.id].Value) > 0 
                                    ?
                                        a.Post === 'Повар 2 группа'
                                            ? 
                                                parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                ?
                                                
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])))
                                                :
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13)))
                                            :
                                            Sum + 0
                                    :
                                    Sum + 0, 0
                                )
                            :
                            TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                parseFloat(a.Hours[item.id].Value) > 0 
                                    ?
                                        a.Post === 'Повар 2 группа' 
                                            ? 
                                                parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                ?
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id]))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                :
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                            :
                                            Sum + 0
                                    :
                                    a.Post === 'Повар 2 группа'
                                    ?
                                    Sum + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                    :
                                    Sum + 0, 0
                                )
                            :
                            TotalSum + 0
                        , 0).toFixed(2)

                    state.ResultCookSecondGroup.TotalSum = parseFloat(parseFloat(state.ResultCookSecondGroup.FirstTotalSum) + parseFloat(state.ResultCookSecondGroup.SecondTotalSum)).toFixed(2)

                    //Управы
                    actions.payload.RevenueArray.map((el) => {
                        state.StaffSelectedCityArray.length > 0 && state.ResultManager.Result.push(state.StaffSelectedCityArray.reduce((Sum, a) => 
                            el.id < 15
                            ?
                            parseFloat(a.Hours[el.id].Value) > 0 
                                ?
                                    a.Post === 'Управляющий'
                                        ?
                                            Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift))
                                        :
                                        Sum + 0
                                :
                                Sum + 0
                            :
                            parseFloat(a.Hours[el.id].Value) > 0 
                                ?
                                    a.Post === 'Управляющий'
                                        ?
                                            Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift))
                                        :
                                        Sum + 0
                                :
                                Sum + 0, 0
                            ).toFixed(2))
                    return(el)
                    })

                    state.ResultManager.FirstTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                        item.id < 15 ?
                            (actions.payload.Period.MaxDay > 14 ? item.id !== 14 : item.id !==  actions.payload.Period.MaxDay - 1)
                            ?
                            TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                parseFloat(a.Hours[item.id].Value) > 0 
                                    ?
                                        a.Post === 'Управляющий'
                                            ? 
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift))
                                            :
                                            Sum + 0
                                    :
                                    Sum + 0, 0
                                )
                            :
                            TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                parseFloat(a.Hours[item.id].Value) > 0 
                                    ?
                                        a.Post === 'Управляющий'
                                            ? 
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift)) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                            :
                                            Sum + 0
                                    :
                                    a.Post === 'Управляющий'
                                    ?
                                    Sum + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                    :
                                    Sum + 0, 0
                                )
                            :
                            TotalSum + 0
                        , 0).toFixed(2)

                        state.ResultManager.SecondTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                            item.id > 14 ?
                                item.id !==  actions.payload.Period.MaxDay - 1
                                ?
                                TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                    item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                    parseFloat(a.Hours[item.id].Value) > 0 
                                        ?
                                            a.Post === 'Управляющий'
                                                ? 
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift))
                                                :
                                                Sum + 0
                                        :
                                        Sum + 0, 0
                                    )
                                :
                                TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                    item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                    parseFloat(a.Hours[item.id].Value) > 0 
                                        ?
                                            a.Post === 'Управляющий'
                                                ? 
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift)) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                :
                                                Sum + 0
                                        :
                                        a.Post === 'Управляющий'
                                        ?
                                        Sum + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                        :
                                        Sum + 0, 0
                                    )
                                :
                                TotalSum + 0
                            , 0).toFixed(2)

                        state.ResultManager.TotalSum = parseFloat(parseFloat(state.ResultManager.FirstTotalSum) + parseFloat(state.ResultManager.SecondTotalSum)).toFixed(2)

                        //Без %

                        actions.payload.RevenueArray.map((el) => {
                            state.StaffSelectedCityArray.length > 0 && state.ResultOther.Result.push(state.StaffSelectedCityArray.reduce((Sum, a) => 
                                el.id < 15
                                ?
                                    parseFloat(a.Hours[el.id].Value) > 0 
                                    ?
                                        (a.Post !== 'Управляющий' && a.Post !== 'Кассир' && a.Post !== 'Повар' && a.Post !== 'Повар 1 группа' && a.Post !== 'Повар 2 группа')
                                        ?
                                            Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift))
                                        :
                                        Sum + 0
                                    :
                                    Sum + 0                                 
                                :
                                    parseFloat(a.Hours[el.id].Value) > 0 
                                    ?
                                        (a.Post !== 'Управляющий' && a.Post !== 'Кассир' && a.Post !== 'Повар' && a.Post !== 'Повар 1 группа' && a.Post !== 'Повар 2 группа')
                                        ?
                                            Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift))
                                        :
                                    Sum + 0
                                :
                                Sum + 0, 0
                                ).toFixed(2))
                        return(el)
                        })

                        state.ResultOther.FirstTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                            item.id < 15 ?
                                (actions.payload.Period.MaxDay > 14 ? item.id !== 14 : item.id !==  actions.payload.Period.MaxDay - 1)
                                ?
                                TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                    item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                    parseFloat(a.Hours[item.id].Value) > 0 
                                        ?
                                            (a.Post !== 'Управляющий' && a.Post !== 'Кассир' && a.Post !== 'Повар' && a.Post !== 'Повар 1 группа' && a.Post !== 'Повар 2 группа')
                                                ? 
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift))
                                                :
                                                Sum + 0
                                        :
                                        Sum + 0, 0
                                    )
                                :
                                TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                    item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                    parseFloat(a.Hours[item.id].Value) > 0 
                                        ?
                                            (a.Post !== 'Управляющий' && a.Post !== 'Кассир' && a.Post !== 'Повар' && a.Post !== 'Повар 1 группа' && a.Post !== 'Повар 2 группа')
                                                ? 
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift)) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                                :
                                                Sum + 0
                                        :
                                        (a.Post !== 'Управляющий' && a.Post !== 'Кассир' && a.Post !== 'Повар' && a.Post !== 'Повар 1 группа' && a.Post !== 'Повар 2 группа')
                                        ?
                                        Sum + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                        :
                                        Sum + 0, 0
                                    )
                                :
                                TotalSum + 0
                            , 0).toFixed(2)
                            
                            state.ResultOther.SecondTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                                item.id > 14 ? 
                                    item.id !== actions.payload.Period.MaxDay - 1
                                    ?
                                    TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                        item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                        parseFloat(a.Hours[item.id].Value) > 0 
                                            ?
                                                (a.Post !== 'Управляющий' && a.Post !== 'Кассир' && a.Post !== 'Повар' && a.Post !== 'Повар 1 группа' && a.Post !== 'Повар 2 группа')
                                                    ? 
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift))
                                                    :
                                                    Sum + 0
                                            :
                                            Sum + 0, 0
                                        )
                                    :
                                    TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                        item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                        parseFloat(a.Hours[item.id].Value) > 0 
                                            ?
                                                (a.Post !== 'Управляющий' && a.Post !== 'Кассир' && a.Post !== 'Повар' && a.Post !== 'Повар 1 группа' && a.Post !== 'Повар 2 группа')
                                                    ? 
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift)) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                    :
                                                    Sum + 0
                                            :
                                            (a.Post !== 'Управляющий' && a.Post !== 'Кассир' && a.Post !== 'Повар' && a.Post !== 'Повар 1 группа' && a.Post !== 'Повар 2 группа')
                                            ?
                                            Sum + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                            :
                                            Sum + 0, 0
                                        )
                                    :
                                    TotalSum + 0
                                , 0).toFixed(2)
                                

                            state.ResultOther.TotalSum = parseFloat(parseFloat(state.ResultOther.FirstTotalSum) + parseFloat(state.ResultOther.SecondTotalSum)).toFixed(2)

                            //Итого ФОТ
                            
                            actions.payload.RevenueArray.map((el) => {
                                state.StaffSelectedCityArray.length > 0 && state.ResultFOT.Result.push(state.StaffSelectedCityArray.reduce((Sum, a) => 
                                    el.id < 15
                                    ?
                                        parseFloat(a.Hours[el.id].Value) > 0 
                                            ?
                                                a.Post === 'Кассир' 
                                                    ? 
                                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[el.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13)))
                                                    :
                                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                                    ? 
                                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[el.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13)))
                                                    :
                                                a.Post === 'Повар 2 группа'
                                                    ? 
                                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[el.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13)))
                                                    :
                                                Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.Rate / a.Shift))
                                            :
                                            Sum + 0                     
                                    :
                                    parseFloat(a.Hours[el.id].Value) > 0 
                                            ?
                                                a.Post === 'Кассир' 
                                                    ? 
                                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[el.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13)))
                                                    :
                                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                                    ? 
                                                        parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[el.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13)))
                                                    :
                                                a.Post === 'Повар 2 группа'
                                                ? 
                                                    parseFloat(el.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                    ?
                                                    Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[el.id])))
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(parseFloat(el.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[el.id])) + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13)))
                                                :
                                                Sum + parseFloat(parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[el.id].Value) * parseFloat(a.SecondRate / a.SecondShift))
                                            :
                                            Sum + 0, 0
                                    ).toFixed(2))
                                    return(el)
                            })

                            state.ResultFOT.FirstTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                                item.id < 15 
                                ?
                                    (actions.payload.Period.MaxDay > 14 ? item.id !== 14 : item.id !== actions.payload.Period.MaxDay - 1)
                                    ?
                                        TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                            item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                            parseFloat(a.Hours[item.id].Value) > 0 
                                            ?
                                                a.Post === 'Кассир' 
                                                ? 
                                                    parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                    ?
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])))
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13)))
                                                :
                                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                                ? 
                                                    parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                    ?
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])))
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13)))
                                                :
                                                a.Post === 'Повар 2 группа'
                                                ? 
                                                    parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                    ?
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])))
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13)))
                                                :
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift))
                                            :
                                            Sum + 0, 0
                                            )
                                    :
                                        TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                            item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                            parseFloat(a.Hours[item.id].Value) > 0 
                                            ?
                                                a.Post === 'Кассир' 
                                                ? 
                                                    parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                    ?
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id]))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                                :
                                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                                ? 
                                                    parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                    ?
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id]))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                                :
                                                a.Post === 'Повар 2 группа'
                                                ? 
                                                    parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                    ?
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id]))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13))) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                                :
                                                Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.Prize / a.Shift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.Rate / a.Shift)) + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value)
                                            :
                                            Sum + parseFloat(a.FirstBonus.Value) - parseFloat(a.FirstFine.Value), 0
                                                 )
                                    :
                                    TotalSum + 0
                                    , 0).toFixed(2)

                                    state.ResultFOT.SecondTotalSum = state.StaffSelectedCityArray.length > 0 && actions.payload.RevenueArray.reduce((TotalSum, item) => 
                                        item.id > 14 
                                        ?
                                            item.id !== actions.payload.Period.MaxDay - 1
                                            ?
                                            TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                                item.id > actions.payload.Period.MinDay && item.id < actions.payload.Period.MaxDay && 
                                                parseFloat(a.Hours[item.id].Value) > 0 
                                                    ?
                                                a.Post === 'Кассир' 
                                                    ? 
                                                        parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13)))
                                                    :
                                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                                    ? 
                                                        parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13)))
                                                    :
                                                a.Post === 'Повар 2 группа'
                                                    ? 
                                                        parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])))
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13)))
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift))
                                                :
                                                Sum + 0, 0
                                            )
                                            :
                                            TotalSum + state.StaffSelectedCityArray.reduce((Sum, a) => 
                                                item.id < actions.payload.Period.MaxDay && item.id > actions.payload.Period.MinDay &&
                                                parseFloat(a.Hours[item.id].Value) > 0 
                                                    ?
                                                a.Post === 'Кассир' 
                                                    ? 
                                                        parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id]))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Kashier))) / state.HoursStaffKashierArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumKashier) / 13))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                    :
                                                (a.Post === 'Повар' || a.Post === 'Повар 1 группа') 
                                                    ? 
                                                        parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id]))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.Cook))) / state.HoursStaffCookArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCook) / 13))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                    :
                                                a.Post === 'Повар 2 группа'
                                                    ? 
                                                        parseFloat(item.Value) < actions.payload.PercentCity.PrizeMinSum 
                                                        ?
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.Shift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id]))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                        :
                                                        Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift) + (parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(parseFloat(item.Value) / 100 * (parseFloat(actions.payload.PercentCity.CookSecondGroup))) / state.HoursStaffCookSecondGroupArray[item.id])) + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(parseFloat(actions.payload.PercentCity.PrizeSumCookSecondGroup) / 13))) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                                    :
                                                    Sum + parseFloat(parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondPrize / a.SecondShift) + parseFloat(a.Hours[item.id].Value) * parseFloat(a.SecondRate / a.SecondShift)) + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value)
                                            :
                                            Sum + parseFloat(a.SecondBonus.Value) - parseFloat(a.SecondFine.Value), 0
                                            )
                                            :
                                            TotalSum + 0
                                        , 0).toFixed(2)

                                    state.ResultFOT.TotalSum = parseFloat(parseFloat(state.ResultFOT.FirstTotalSum) + parseFloat(state.ResultFOT.SecondTotalSum)).toFixed(2)
                            
        },
        EditPost(state, actions){
            state.StaffSelectedCityArray.map((el) => {
                if(el.id === actions.payload.id)
                {
                    el.Post = actions.payload.Post
                }
                return(el)
            })

            state.StaffArray.map((el) => {
                if(el.id === actions.payload.id)
                {
                    el.Post = actions.payload.Post
                }
                return(el)
            })
        }
    }
})

export default StaffSlice.reducer
export const { EditPost, StaffSelectedCityArray, AddResult, setHoursStaff, setStaffAllMonth, StaffArrayAdd, StaffHours, StaffSelectedCityArrayAdd, changeValueStaff, TotalSumHour, ChangeShift, ChangeRate, ChangePrize, ChangeFIO, ChangeAdditional, StaffOneDaySumHours, StaffChangeHidden, StaffUnHidden, setStaffDeletedStatus, StaffUnDeletedStatus } = StaffSlice.actions